import { LegalLayout, Article, SubArticle, P, Dash } from '@/components/LegalLayout';

export default function ConfidentialitéPage() {
  return (
    <LegalLayout
      title="Politique de Confidentialité"
      subtitle="Protection des données personnelles — Conformite RGPD et loi Informatique et Libertés"
      date="Version en vigueur au 06 avril 2026"
    >
      <div style={{ background: '#f4efe6', borderRadius: 8, padding: '20px 24px', marginBottom: 32, fontSize: 13, lineHeight: 1.9 }}>
        <strong style={{ color: '#111622' }}>Préambule et engagement</strong><br/>
        BENCHORY SAS (ci-après "BENCHORY") considère la protection des données personnelles de ses utilisateurs comme une responsabilité fondamentale et non negociable. La confiance que nos Abonnes nous accordent en partageant leurs données financieres est un actif que nous protègeons avec la plus grande rigueur.
      </div>

      <Article num="Article 1" title="Responsable du traitement">
        <P>Le responsable du traitement au sens de l'article 4(7) du RGPD est :</P>
        <div style={{ background: '#f4efe6', borderRadius: 8, padding: '20px 24px', marginBottom: 16, fontSize: 13, lineHeight: 2 }}>
          <strong>Dénomination :</strong> BENCHORY SAS<br/>
          <strong>Siège social :</strong> La Rochelle (17000), France<br/>
          <strong>SIRET :</strong> [À compléter à l'immatriculation]<br/>
          <strong>Email :</strong> contact@benchory.fr<br/>
          <strong>Representant legal :</strong> Yovan LEFRESNE, Président
        </div>
        <P>Pour toute question relative au traitement de vos données personnelles ou pour exercer vos droits, vous pouvez contacter BENCHORY à l'adresse email ci-dessus ou par courrier au siege social.</P>
      </Article>

      <Article num="Article 2" title="Données collectees">
        <SubArticle num="2.1" title="Données d'identification et de contact">
          <P>Collectees lors de la création du Compte et pendant la durée de l'abonnement :</P>
          <Dash>Nom et prenom du titulaire du compte (obligatoire)</Dash>
          <Dash>Adresse email professionnelle (obligatoire)</Dash>
          <Dash>Numéro de telephone professionnel (facultatif)</Dash>
          <Dash>Nom commercial de l'Établissement (obligatoire)</Dash>
          <Dash>Adresse physique complete de l'Établissement (obligatoire)</Dash>
          <Dash>Numéro SIRET de la structure professionnelle (obligatoire)</Dash>
          <Dash>Dénomination sociale et forme juridique (obligatoire)</Dash>
          <Dash>Groupement d'appartenance le cas echeant (facultatif)</Dash>
        </SubArticle>
        <SubArticle num="2.2" title="Données financieres et operationnelles de l'Établissement">
          <P>Saisies mensuellement par l'Abonne dans le cadre de l'utilisation du service :</P>
          <Dash>Indicateurs financiers mensuels (chiffre d'affaires, achats de marchandises, couts salariaux, charges externes, tresorerie, données de stock)</Dash>
          <Dash>Indicateurs d'activité spécifiques au secteur (ordonnances, clientele, taux de generiques, données tiers payant)</Dash>
          <Dash>Reponses au questionnaire qualitatif mensuel</Dash>
          <Dash>Historique des données saisies depuis l'ouverture du Compte</Dash>
          <P style={{ marginTop: 8, fontStyle: 'italic', color: '#666' }}>Ces données ont un caractère strictement professionnel et commercial. Elles ne comprennent aucune donnee de sante des patients, aucune donnee sensible au sens de l'article 9 du RGPD.</P>
        </SubArticle>
        <SubArticle num="2.3" title="Données de facturation">
          <Dash>Coordonnées bancaires (RIB/IBAN) pour le prelevement SEPA, stockees et traitees par notre prestataire Stripe dans un environnement certifie PCI-DSS</Dash>
          <Dash>Historique des factures et des transactions</Dash>
          <Dash>Informations fiscales professionnelles</Dash>
          <P style={{ marginTop: 8, fontStyle: 'italic', color: '#666' }}>BENCHORY ne stocke jamais directement de numéro de carte bancaire sur ses propres serveurs.</P>
        </SubArticle>
        <SubArticle num="2.4" title="Données de navigation et techniques">
          <Dash>Adresse IP et données de géolocalisation approximative</Dash>
          <Dash>Type et version du navigateur web et du système d'exploitation</Dash>
          <Dash>Pages visitees, durée et frequence de visite, parcours de navigation</Dash>
          <Dash>Données de connexion (date, heure, durée des sessions)</Dash>
          <Dash>Journaux d'erreurs et données de diagnostic technique</Dash>
        </SubArticle>
        <SubArticle num="2.5" title="Données de communication">
          <Dash>Historique des emails echanges avec BENCHORY</Dash>
          <Dash>Demandes de support et tickets d'assistance</Dash>
          <Dash>Feedback et evaluations du service</Dash>
        </SubArticle>
      </Article>

      <Article num="Article 3" title="Finalites et bases légales des traitements">
        <div style={{ overflowX: 'auto', marginBottom: 16 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead>
              <tr style={{ background: '#111622', color: '#FAF8F5' }}>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 500 }}>Finalite</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 500 }}>Base légale</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['Création et gestion du Compte utilisateur', 'Art. 6(1)(b) — Execution du contrat'],
                ['Fourniture du service d\'analyse mensuel', 'Art. 6(1)(b) — Execution du contrat'],
                ['Generation des Rapports personnalises par IA', 'Art. 6(1)(b) — Execution du contrat'],
                ['Construction de la Cohorte comparative anonymisee', 'Art. 6(1)(f) — Intérêt legitime'],
                ['Amelioration des algorithmes et methodes d\'analyse', 'Art. 6(1)(f) — Intérêt legitime'],
                ['Facturation et gestion des abonnements', 'Art. 6(1)(b) + 6(1)(c) — Contrat + Obligation légale'],
                ['Envoi des emails transactionnels', 'Art. 6(1)(b) — Execution du contrat'],
                ['Support client et gestion des réclamations', 'Art. 6(1)(b) — Execution du contrat'],
                ['Sécurité des systèmes', 'Art. 6(1)(f) — Intérêt legitime'],
                ['Communication commerciale', 'Art. 6(1)(f) — Intérêt legitime (B2B)'],
              ].map(([f, b], i) => (
                <tr key={i} style={{ background: i % 2 === 0 ? '#f9f7f3' : '#fff' }}>
                  <td style={{ padding: '8px 12px' }}>{f}</td>
                  <td style={{ padding: '8px 12px', fontSize: 11, color: '#666' }}>{b}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <P>BENCHORY ne procédé jamais a du profilage automatise susceptible de produire des effets juridiques significatifs au sens de l'article 22 du RGPD.</P>
      </Article>

      <Article num="Article 4" title="L'anonymisation et la Cohorte comparative — garanties spécifiques">
        <SubArticle num="4.1" title="Principe d'anonymisation">
          <P>La Cohorte comparative est construite exclusivement a partir de données rigoureusement anonymisees. L'anonymisation est un procèssus irréversible par lequel toute information permettant d'identifiér directement ou indirectement un Établissement est supprimee ou altérée de facon permanente.</P>
        </SubArticle>
        <SubArticle num="4.2" title="Processus d'anonymisation">
          <Dash>Suppression de tous les identifiants directs (nom de l'établissement, adresse, SIRET, email)</Dash>
          <Dash>Agregation des données financieres dans des plages de valeurs empechant l'identification</Dash>
          <Dash>Application de techniques de perturbation des données (ajout de bruit statistique contrôle)</Dash>
          <Dash>Vérification systématique que les données publiees ne permettent pas de remonter à un Établissement spécifique</Dash>
        </SubArticle>
        <SubArticle num="4.3" title="Garanties à l'egard des Abonnes">
          <P>BENCHORY garantit formellement :</P>
          <Dash>Qu'aucun Abonne ne peut avoir accès aux données identifiées ou identifiables d'un autre Établissement</Dash>
          <Dash>Que les positionnements comparatifs fournis ne permettent pas d'identifiér les Établissements constituant la Cohorte</Dash>
          <Dash>Que les données anonymisees ne sont pas concernees par les droits d'acces, de rectification ou d'effacement</Dash>
        </SubArticle>
        <SubArticle num="4.4" title="Utilisation de l'intelligence artificielle">
          <P>Les commentaires analytiques contenus dans les Rapports sont generes par un système d'intelligence artificielle (modele Claude d'Anthropic). Les données transmises à ce système sont préalablement pseudonymisées. Anthropic est sous-traitant de BENCHORY et traite ces données dans le cadre d'un accord de traitement des données conforme au RGPD.</P>
        </SubArticle>
      </Article>

      <Article num="Article 5" title="Destinataires et sous-traitants">
        <SubArticle num="5.2" title="Sous-traitants">
          <div style={{ overflowX: 'auto', marginBottom: 16 }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
              <thead>
                <tr style={{ background: '#111622', color: '#FAF8F5' }}>
                  <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 500 }}>Sous-traitant</th>
                  <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 500 }}>Role</th>
                  <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 500 }}>Pays</th>
                </tr>
              </thead>
              <tbody>
                {[
                  ['Emergent', 'Hébergement de la plateforme et des données', 'Etats-Unis'],
                  ['Stripe', 'Traitement securise des paiements (PCI-DSS)', 'Etats-Unis / UE'],
                  ['Resend', 'Envoi des emails transactionnels', 'Etats-Unis'],
                  ['Anthropic', 'Generation des commentaires IA (données pseudonymisées)', 'Etats-Unis'],
                ].map(([n, r, p], i) => (
                  <tr key={i} style={{ background: i % 2 === 0 ? '#f9f7f3' : '#fff' }}>
                    <td style={{ padding: '8px 12px', fontWeight: 600 }}>{n}</td>
                    <td style={{ padding: '8px 12px' }}>{r}</td>
                    <td style={{ padding: '8px 12px', fontSize: 11, color: '#666' }}>{p}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </SubArticle>
        <SubArticle num="5.4" title="Absence de vente de données">
          <P><strong>BENCHORY s'engage formellement et irrévocablement a ne jamais vendre, louer, ceder, echanger ou monétiser de quelque maniere que ce soit les données personnelles ou financieres de ses Abonnes à des tiers. Cette interdiction est absolue et ne souffre d'aucune exception commerciale.</strong></P>
        </SubArticle>
      </Article>

      <Article num="Article 6" title="Durées de conservation">
        <div style={{ overflowX: 'auto', marginBottom: 16 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead>
              <tr style={{ background: '#111622', color: '#FAF8F5' }}>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 500 }}>Categorie</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 500 }}>Durée de conservation</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['Données de compte', 'Durée de l\'abonnement + 3 ans apres résiliation'],
                ['Données financieres mensuelles et Rapports', 'Durée de l\'abonnement + 30 jours apres résiliation'],
                ['Données de facturation et comptables', '10 ans (obligation légale)'],
                ['Données de paiement (via Stripe)', '18 mois max apres derniere transaction'],
                ['Données de navigation et logs techniques', '13 mois maximum (recommandation CNIL)'],
                ['Correspondances et communications', '5 ans a compter de la derniere communication'],
                ['Données anonymisees dans la Cohorte', 'Conservees indefiniment (hors champ RGPD)'],
                ['Données de support client', '3 ans a compter de la cloture du ticket'],
              ].map(([c, d], i) => (
                <tr key={i} style={{ background: i % 2 === 0 ? '#f9f7f3' : '#fff' }}>
                  <td style={{ padding: '8px 12px', fontWeight: 500 }}>{c}</td>
                  <td style={{ padding: '8px 12px' }}>{d}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <P>À l'issue des durées de conservation, les données sont supprimees de maniere securisee et définitive, ou rendues irréversiblement anonymes.</P>
      </Article>

      <Article num="Article 7" title="Sécurité des données">
        <SubArticle num="7.2" title="Mesures techniques">
          <Dash>Chiffrement de toutes les données en transit via le protocole TLS 1.3 (HTTPS)</Dash>
          <Dash>Chiffrement des données sensibles au repos (données financieres, mots de passe hashes)</Dash>
          <Dash>Authentification forte pour l'acces aux systèmes internes</Dash>
          <Dash>Architecture de separation des données par Abonne (isolation des environnements)</Dash>
          <Dash>Sauvegardes régulières chiffrees avec tests de restauration périodiques</Dash>
          <Dash>Surveillance continue des accès et journalisation des operations sensibles</Dash>
          <Dash>Mise a jour régulière des composants logiciels pour corriger les vulnérabilités connues</Dash>
        </SubArticle>
        <SubArticle num="7.3" title="Mesures organisationnelles">
          <Dash>Accès aux données strictement limite aux personnels habilités selon le principe du moindre privilege</Dash>
          <Dash>Sensibilisation et formation régulière du personnel à la protection des données</Dash>
          <Dash>Processus de gestion des incidents de sécurité formalisé</Dash>
          <Dash>Revue périodique des accès et des habilitations</Dash>
        </SubArticle>
        <SubArticle num="7.4" title="Violation de données">
          <P>En cas de violation de données, BENCHORY s'engage a :</P>
          <Dash>Notifier la violation à la CNIL dans les 72 heures suivant sa decouverte</Dash>
          <Dash>Informer dans les meilleurs delais les personnes concernees lorsque la violation est susceptible d'engendrer un risque eleve</Dash>
          <Dash>Documenter la violation et les mesures prises dans le registre des violations</Dash>
        </SubArticle>
      </Article>

      <Article num="Article 8" title="Vos droits sur vos données personnelles">
        <div style={{ overflowX: 'auto', marginBottom: 16 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead>
              <tr style={{ background: '#111622', color: '#FAF8F5' }}>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 500 }}>Droit</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 500 }}>Fondement</th>
                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 500 }}>Description</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['Droit d\'acces', 'Art. 15 RGPD', 'Obtenir la confirmation que des données vous concernant sont traitees et en obtenir une copie'],
                ['Droit de rectification', 'Art. 16 RGPD', 'Faire corriger des données inexactes ou incompletes'],
                ['Droit a l\'effacement', 'Art. 17 RGPD', 'Demander la suppression de vos données dans les cas prevus par la loi'],
                ['Droit à la limitation', 'Art. 18 RGPD', 'Demander la suspension temporaire du traitement'],
                ['Droit à la portabilite', 'Art. 20 RGPD', 'Recevoir vos données dans un format structure (JSON ou CSV)'],
                ['Droit d\'opposition', 'Art. 21 RGPD', 'Vous opposer à un traitement fonde sur l\'intérêt legitime'],
              ].map(([d, f, desc], i) => (
                <tr key={i} style={{ background: i % 2 === 0 ? '#f9f7f3' : '#fff' }}>
                  <td style={{ padding: '8px 12px', fontWeight: 600, color: '#B8924A' }}>{d}</td>
                  <td style={{ padding: '8px 12px', fontSize: 11, color: '#666' }}>{f}</td>
                  <td style={{ padding: '8px 12px' }}>{desc}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <SubArticle num="8.2" title="Modalites d'exercice">
          <P>Pour exercer l'un quelconque de vos droits, adressez votre demande à BENCHORY par :</P>
          <Dash>Email : contact@benchory.fr (avec pour objet : "Exercice de droits RGPD — [Votre nom]")</Dash>
          <Dash>Courrier : BENCHORY SAS — Service Protection des Données — [Adresse siege]</Dash>
          <P>BENCHORY s'engage a repondre à toute demande d'exercice de droits dans un délai d'un (1) mois. Ce délai peut etre porte a trois (3) mois en cas de demandes complexes.</P>
        </SubArticle>
        <SubArticle num="8.3" title="Droit de réclamation">
          <P>Vous disposez du droit d'introduire une réclamation aupres de :</P>
          <div style={{ background: '#f4efe6', borderRadius: 8, padding: '16px 20px', marginTop: 8, fontSize: 13, lineHeight: 1.8 }}>
            <strong>Commission Nationale de l'Informatique et des Libertés (CNIL)</strong><br/>
            3 Place de Fontenoy — TSA 80715 — 75334 Paris Cedex 07<br/>
            <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" style={{ color: '#B8924A' }}>www.cnil.fr</a> — Téléphone : 01 53 73 22 22
          </div>
        </SubArticle>
      </Article>

      <Article num="Article 9" title="Cookies et traceurs">
        <SubArticle num="9.1" title="Types de cookies utilises">
          <div style={{ overflowX: 'auto', marginBottom: 16 }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
              <thead>
                <tr style={{ background: '#111622', color: '#FAF8F5' }}>
                  <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 500 }}>Categorie</th>
                  <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 500 }}>Finalite</th>
                  <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 500 }}>Consentement</th>
                </tr>
              </thead>
              <tbody>
                {[
                  ['Cookies strictement nécessaires', 'Fonctionnement de la plateforme : maintien de session, sécurité', 'Non (intérêt legitime)'],
                  ['Cookies d\'analyse technique', 'Mesure d\'audience anonymisee', 'Oui (si non anonymises)'],
                  ['Cookies de support', 'Identification pour le chat de support', 'Oui'],
                ].map(([c, f, co], i) => (
                  <tr key={i} style={{ background: i % 2 === 0 ? '#f9f7f3' : '#fff' }}>
                    <td style={{ padding: '8px 12px', fontWeight: 500 }}>{c}</td>
                    <td style={{ padding: '8px 12px' }}>{f}</td>
                    <td style={{ padding: '8px 12px', fontSize: 11 }}>{co}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </SubArticle>
        <SubArticle num="9.2" title="Absence de cookies publicitaires">
          <P>BENCHORY n'utilise aucun cookie à des fins publicitaires, de ciblage comportemental ou de revente à des régies publicitaires.</P>
        </SubArticle>
      </Article>

      <Article num="Article 10" title="Modifications de la Politique de Confidentialité">
        <P>BENCHORY se réserve le droit de modifier la présente Politique de Confidentialité à tout moment. Toute modification substantielle sera notifiee aux Abonnes par email au moins trente (30) jours avant son entree en vigueur. La version en vigueur est celle accessible à l'adresse <a href="/confidentialité" style={{ color: '#B8924A' }}>benchory.fr/confidentialité</a>.</P>
      </Article>

      <Article num="Article 11" title="Droit applicable">
        <P>La présente Politique de Confidentialité est soumise au droit français et au droit de l'Union Europeenne, notamment le RGPD. En cas de litige, les juridictions françaises compétentes seront saisies, sans prejudice du droit de l'Utilisateur de saisir la CNIL.</P>
      </Article>

      <div style={{ marginTop: 48, padding: '16px 0', borderTop: '1px solid #E8E0D4', fontSize: 12, color: '#999', textAlign: 'center' }}>
        BENCHORY SAS — Politique de Confidentialité — Version du 06/04/2026
      </div>
    </LegalLayout>
  );
}
